module.exports = __webpack_public_path__ + "img/logo-mamas.d986bff0.png";